import { useMemo } from 'react';
import JSON_DATA_HEADER from '../data/header.json';
export const useHeader = () => {
    return useMemo(() => JSON_DATA_HEADER, []);
};
